import { Icons } from '@agro-club/agroclub-shared'
import { FC, useState } from 'react'
import { SamplePartsTab } from '../../types'
import styled from 'styled-components'
import { AButton } from 'views/components/Analytics'
import { SharedModalContent } from 'views/components/SharedModal'
import { SamplePartsTabs } from './SamplePartsTabs'
import { Card } from 'views/components/Card/Card'
import { SamplePartsFullScreen } from './SamplePartsFullScreen'

type Props = {
  parts: SamplePartsTab[]
  sampleId: number
}

export const FullScreenContent = styled(SharedModalContent)`
  max-height: calc(100dvh - 200px);
`

const TableWrapper = styled.div`
  position: relative;
`
const AbsoluteButton = styled(AButton)`
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 100;
`

export const SampleParts: FC<Props> = ({ sampleId, parts }) => {
  const [fullScreen, setFullScreen] = useState(false)
  return fullScreen ? (
    <SamplePartsFullScreen data={parts} sampleId={sampleId} onClose={() => setFullScreen(false)} />
  ) : (
    <TableWrapper>
      <AbsoluteButton
        Icon={Icons.IconFullscreen}
        id="samplePartsFullScreen"
        color="secondary"
        onClick={() => setFullScreen(true)}
      />
      <Card.Container>
        <SamplePartsTabs data={parts} sampleId={sampleId} />
      </Card.Container>
    </TableWrapper>
  )
}
